import domready from "domready";
import Flatpickr from "flatpickr";
import FlatpickrMonthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/l10n/de";
export default (function () {
  var locale = document.documentElement.getAttribute("lang") || "en-US";
  var localeRoot = locale.substring(0, 2);
  if (Flatpickr.l10ns[localeRoot]) {
    Flatpickr.localize(Flatpickr.l10ns[localeRoot]);
  }
  var test = document.createElement("input");
  try {
    test.type = "month";
  } catch (e) {}
  var monthIsSupported = test.type === "month";
  domready(function () {
    var datePickers = document.querySelectorAll(".date-dummy[type=\"date\"], .date-dummy[type=\"month\"]");
    if (datePickers.length > 0) {
      console.warn('Deprecated datepicker: Use `toujou-datepicker` web component instead');

      Array.prototype.forEach.call(datePickers, function (el) {
        var initialType = el.type.toLowerCase();
        var initialValueAttribute = el.getAttribute("value");
        var parent = el.parentElement;
        var format = parent.dataset.format;
        var from = parent.dataset.from;
        var until = parent.dataset.until;
        var monthpicker = parent.dataset.monthpicker;
        var range = parent.dataset.range;
        var time = parent.dataset.time;
        function detectEmptyValueAndReflectToClass() {
          var addOrRemove = !el.value || el.value === format || el.value === el.placeholder ? "add" : "remove";
          el.classList[addOrRemove]("date-dummy--empty");
          if (el.nextElementSibling && (!el.nextElementSibling.name && el.nextElementSibling.classList.contains("date-dummy"))) {
            el.classList[addOrRemove]("date-dummy--empty");
          }
        }
        el.addEventListener("change", detectEmptyValueAndReflectToClass);
        var confObj = {
          mode: range === "true" && monthpicker !== "1" ? "range" : "single",
          dateFormat: format,
          allowInput: false
        };
        if (el.value == "" && initialValueAttribute) {
          try {
            var selectedDate = Flatpickr.parseDate(initialValueAttribute, format);
            if (selectedDate) {
              confObj.defaultDate = selectedDate;
            }
          } catch (exception) {}
        }
        if (time) {
          confObj.enableTime = true;
          confObj.time_24hr = true;
        } else {
          if (monthpicker === "1") {
            confObj.altInput = true;
            // This is essentially the mobile check
            if (window.navigator.maxTouchPoints === 0 || !monthIsSupported) {
              confObj.plugins = [new FlatpickrMonthSelect({
                dateFormat: "d.m.Y",
                altFormat: "F Y"
              })];
            } else {
              confObj.altFormat = "F Y";
            }
          } else {
            var dateFormatRegex = new RegExp("([0-9]{2}[.][0-9]{2}[.][0-9]{4})");
            if (from !== undefined) {
              if (from === "true") {
                confObj.minDate = "today";
              } else {
                if (dateFormatRegex.test(from)) {
                  from = reverseDateString(from);
                }
                from = Flatpickr.parseDate(from, "Y-m-d");
                confObj.minDate = Flatpickr.compareDates(new Date(), from) >= 0 ? "today" : from;
              }
            }
            if (until !== undefined) {
              if (dateFormatRegex.test(until)) {
                until = reverseDateString(until);
              }
              until = Flatpickr.parseDate(until, "Y-m-d");
              confObj.maxDate = until;
              if (until === "true") {
                confObj.minDate = "today";
              } else {
                until = Flatpickr.parseDate(until, "Y-m-d");
                confObj.maxDate = until;
              }
            }
          }
        }
        function reverseDateString(dateString) {
          return dateString.split(".").reverse().join();
        }
        var fp = Flatpickr(el, confObj);
        if (monthpicker === "1" && initialType === "month" && fp.isMobile) {
          fp.mobileFormatStr = "Y-m";
          fp.mobileInput.type = initialType;
        }
        detectEmptyValueAndReflectToClass();
      });
    }
  });
})();
